import { formatDateTime } from '@/lib/formatters';

interface DateTimeCellProps {
  date: string;
}

export function DateTimeCell({ date }: DateTimeCellProps) {
  return <span className="text-sm text-gray-500">{formatDateTime(date)}</span>;
}
